import { defineStore } from 'pinia'

import type { IUser } from '~/entities/user/user/interfaces/user'
import { useUsersStore } from '~/entities/user/user/stores/users'

import * as RTConv from '~/features-shared/rtconv/api/rtinterface-senders'
import type { RTCUserId } from '~/features-shared/rtconv/interfaces/rtconversation'

/**
 * Users store for RTC.
 * todo: ideally, should be merged with 'users' store.
 */
export const useUsersStoreV2 = defineStore('users-v2', () => {
  const storeUsers = useUsersStore()

  // #region STATES
  const users = reactive<Map<RTCUserId, IUser>>(new Map())

  // #region GETTERS
  const currentUser = computed(() => storeUsers.currentUser)

  const getUser = async (userId: RTCUserId | string) => {
    if (typeof userId === 'string')
      userId = Number(userId)
    if (Number.isNaN(userId))
      return // not a RTC user

    let user = users.get(userId)
    if (!user) {
      user = await RTConv.getUser({ userId, waitForResponse: true })
      setUser(userId, user)
    }
    return user
  }

  // #region METHODS
  const setUser = (userId: RTCUserId, user: IUser) => {
    users.set(userId, user)
  }

  return {
    currentUser,
    getUser,
    setUser,
  }
})
